import React from 'react';
import { TrainingShell } from '../components/TrainingV2';

const DataCatalogTraining: React.FC = () => {
  return (
    <TrainingShell
      moduleId="data-catalog-fundamentals"
      moduleName="Data Catalog Fundamentals"
      backUrl="/learn101"
    />
  );
};

export default DataCatalogTraining;
